// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton--closeButton--1iOhW","closeButton__svg":"CloseButton--closeButton__svg--tF49O","placeholderAnim":"CloseButton--placeholderAnim--1rleB"};